import { getPromoDetails, applyPromo } from 'Api/AccountApi';
import { getState, setState } from 'Utils/Store';
import { onSubmitReactFormError } from 'Utils/FormValidation';

export const promoCodeInitialState = {
  couponCode: '',
  promoDescription: '',
  plan: '',
  priceToBeCharged: '',
  hasApplied: false,
  isValid: false,
  isFlatDiscount: false,
  nextBillingDateTime: '',
  emailCoupon: '',
  validCouponCodeLabel: '',
  autoApplyCoupon: false,
};

export const invalidPromoCode = (payload) =>
  setState('promoCode', {
    isValid: false,
    hasApplied: true,
    validCouponCodeLabel: '',
    plan: '',
    priceToBeCharged: '',
    promoDescription: '',
    couponCode: payload.couponCode || '',
    emailCoupon: '',
    nextBillingDateTime: '',
  });

export const resetPromoCode = () => setState('promoCode', promoCodeInitialState);

export const setPromoCode = (payload) => setState('promoCode', { ...payload, isValid: true });

export const resetAppliedState = () => setState('promoCode', { hasApplied: false });

// to be used only for auto-filling coupon code using an email deeplink.
export const setEmailCoupon = (payload) => setState('promoCode', { emailCoupon: payload || '' });
// to be used only for automatically applying the coupon using an email deeplink.
export const autoApplyEmailCoupon = (payload) => setState('promoCode', { autoApplyCoupon: payload || false });

export const validatePromoCode = (couponCode, planId) => {
  const {
    plans: { selectedPlanId },
    promoCode: { emailCoupon },
  } = getState();
  const plan = planId || selectedPlanId;
  if (!plan) {
    console.error('No plan selected', { couponCode, plan });
  }
  // if user enters the promo code, call evergent getVoucherDetails api
  if (couponCode && plan) {
    return getPromoDetails(plan, couponCode)
      .then((promoDetails) => {
        const { isValid, errorMessage, promoDescription, isFlatDiscount, priceToBeCharged, nextBillingDateTime } =
          promoDetails;
        if (isValid) {
          const validPromoCodeDetails = {
            couponCode,
            promoDescription,
            isFlatDiscount,
            nextBillingDateTime,
            hasApplied: true,
            plan,
            priceToBeCharged,
            validCouponCodeLabel: 'Your code has been applied.',
          };
          if (couponCode !== emailCoupon) {
            validPromoCodeDetails.emailCoupon = '';
          }

          setPromoCode(validPromoCodeDetails);
        } else {
          invalidPromoCode({ couponCode });
          throw Error(errorMessage);
        }
      })
      .catch((error) => {
        invalidPromoCode({ couponCode });
        return onSubmitReactFormError(error.message, 401, 'Invalid coupon code');
      });
  }
  return resetPromoCode();
};

export const applyPromoCode = (couponCode) => {
  // if user enters the promo code, call evergent applyCouponV2 api
  if (couponCode) {
    return applyPromo(couponCode).then((response) => {
      const { isSuccess, errorMessage, isPaymentMethodError } = response;
      if (isSuccess) {
        const payload = {
          couponCode,
          hasApplied: true,
          validCouponCodeLabel: 'Code applied',
        };
        setPromoCode(payload);
        return response;
      }
      invalidPromoCode({ couponCode });
      return { isPaymentMethodError, isSuccess, errorMessage };
    });
  }
  return invalidPromoCode({ couponCode });
};
